export const TRANSLATIONS_PT_DASHBOARD_AND_KNOWLEDGE = {
  "dashboard.title": "Painel",
  "dashboard.documents": "Documentos",
  "dashboard.credits": "Créditos",
  "dashboard.users": "Usuários Ativos",
  "dashboard.questions": "Perguntas",
  "dashboard.embeddings": "Embeddings",
  "dashboard.status": "Status do Sistema",
  "dashboard.widget.plan_usage": "Uso do Plano",
  "dashboard.widget.csv_stats": "Estatísticas CSV",
  "dashboard.widget.csv_stats.uploaded": "Arquivos CSV enviados",
  "dashboard.widget.csv_stats.queries": "Consultas executadas",
  "dashboard.widget.documents_stats": "Estatísticas de Documentos",
  "dashboard.widget.documents_stats.count": "Documentos enviados",
  "dashboard.widget.documents_stats.duplicates": "Duplicados",
  "dashboard.widget.documents_stats.this_month": "Este mês",
  "dashboard.widget.email_stats": "Estatísticas de E-mails",
  "dashboard.widget.email_stats.sent": "E-mails processados",
  "dashboard.widget.email_stats.received": "E-mails convertidos em tarefas",
  "dashboard.widget.tokens_breakdown": "Detalhamento de Tokens",
  "dashboard.widget.tokens_breakdown.input": "Tokens usados (embeddings)",
  "dashboard.widget.tokens_breakdown.output": "Tokens usados (RAG)",
  "dashboard.widget.tokens_breakdown.exceeded": "Limite de tokens excedido",
  "dashboard.widget.rag_queries": "Consultas RAG",
  "dashboard.widget.rag_queries.count": "Consultas RAG",
  "dashboard.widget.rag_queries.top_users": "Top usuários:",
  "dashboard.widget.plan_usage.used": "Usados",
  "dashboard.widget.plan_usage.remaining": "Restantes",
  "dashboard.widget.plan_usage.total": "Total",
  "dashboard.widget.plan_usage.exceeded": "Limite do plano excedido",
  "dashboard.widget.user_activity": "Atividade dos Usuários",
  "dashboard.widget.inactive_users": "Usuários Inativos",
  "dashboard.widget.user_activity.active": "Usuários Ativos",
  "dashboard.widget.user_activity.inactive": "Usuários Inativos",
  "dashboard.widget.inactive_users.count": "Usuários Inativos",
  "dashboard.loading": "Carregando...",
  "dashboard.context_menu.add_widget": "Adicionar Widget",
  "dashboard.context_menu.remove_widget": "Remover Widget",
  "dashboard.context_menu.title": "Widgets Disponíveis",
  "dashboard.context_menu.group.others": "Outros",
  "dashboard.context_menu.widget.csv": "CSV",
  "dashboard.context_menu.widget.consultas_rag": "Consultas RAG",
  "dashboard.context_menu.widget.tokens": "Tokens",
  "dashboard.context_menu.widget.emails": "E-mails",
  "dashboard.context_menu.widget.documentos": "Documentos",
  "dashboard.context_menu.widget.usuarios_inactivos": "Usuários Inativos",
  "dashboard.empty":
    "Clique com o botão direito para adicionar widgets ao painel.",
  "dashboard.widget.title.plan_usage": "Uso do Plano",
  "dashboard.widget.title.csv_stats": "Estatísticas CSV",
  "dashboard.widget.title.documents_stats": "Estatísticas de Documentos",
  "dashboard.widget.title.email_stats": "Estatísticas de E-mails",
  "dashboard.widget.title.tokens_breakdown": "Detalhamento de Tokens",
  "dashboard.widget.title.rag_queries": "Consultas RAG",
  "dashboard.widget.title.user_activity": "Atividade dos Usuários",
  "dashboard.widget.title.inactive_users": "Usuários Inativos",
  "dashboard.context_menu.widget.plan_usage": "Uso do Plano",
  "dashboard.context_menu.widget.csv_stats": "Estatísticas CSV",
  "dashboard.context_menu.widget.documents_stats": "Estatísticas de Documentos",
  "dashboard.context_menu.widget.email_stats": "Estatísticas de E-mails",
  "dashboard.context_menu.widget.tokens_breakdown": "Detalhamento de Tokens",
  "dashboard.context_menu.widget.rag_queries": "Consultas RAG",
  "dashboard.context_menu.widget.user_activity": "Atividade dos Usuários",
  "dashboard.context_menu.widget.inactive_users": "Usuários Inativos",
  "dashboard.widget.user_activity.last_active": "Última atividade",
  "dashboard.widget.user_activity.user": "Usuário",
  "dashboard.active_users_this_month": "Usuários ativos este mês:",
  "dashboard.active_users_today": "Usuários ativos hoje",
  "dashboard.name": "Nome",
  "dashboard.last_login": "Último login",
  "dashboard.last_activity": "Última atividade",
  "dashboard.inactive_users_this_month": "Usuários inativos este mês:",
  "dashboard.days_without_activity": "dias sem atividade",
  "dashboard.no_inactive_users": "Não há usuários inativos este mês.",
  "dashboard.questions_today": "Perguntas hoje",
  "dashboard.system_status": "Status do sistema",
  "dashboard.action": "Ação",
  "dashboard.context_menu.no_widgets": "Sem widgets para adicionar",
  "changes.title": "Mudancas entre versoes",
  "changes.empty": "Nenhuma mudanca detectada.",
  "changes.filter.allSeverities": "Todas as severidades",
  "changes.filter.allStatuses": "Todos os estados",
  "changes.general.loading": "Carregando...",
  "changes.general.retry": "Tentar de novo",
  "changes.error.message": "Nao foi possivel carregar as mudancas.",
  "changes.evidence.before": "Antes",
  "changes.evidence.after": "Depois",
  "changes.action.confirm": "Confirmar",
  "changes.action.needsReview": "A revisar",
  "changes.action.dismiss": "Descartar",
  "changes.action.dismissReason": "Motivo (opcional)",
  "changes.severity.informational": "informativo",
  "changes.severity.low": "baixo",
  "changes.severity.medium": "medio",
  "changes.severity.high": "alto",
  "changes.severity.critical": "critico",
  "changes.status.detected": "detectado",
  "changes.status.needs_review": "a revisar",
  "changes.status.confirmed": "confirmado",
  "changes.status.dismissed": "descartado",
  "changes.status.superseded": "substituido",
  "changes.category.legal": "juridico",
  "changes.category.financial": "financeiro",
  "changes.category.operational": "operacional",
  "changes.category.compliance": "conformidade",
  "changes.category.commercial": "comercial",
  "changes.category.technical": "tecnico",
  "changes.category.human_resources": "RH",
  "changes.category.security": "seguranca",
  "changes.category.general": "geral",
  "alerts.title": "Alertas de conhecimento",
  "alerts.empty": "Nao ha alertas ativos.",
  "alerts.filter.allSeverities": "Todas as severidades",
  "alerts.filter.allStatuses": "Todos os estados",
  "alerts.filter.allSources": "Todas as fontes",
  "alerts.general.loading": "Carregando...",
  "alerts.general.retry": "Tentar novamente",
  "alerts.error.message": "Nao foi possivel carregar os alertas.",
  "alerts.severity.informational": "informativo",
  "alerts.severity.low": "baixo",
  "alerts.severity.medium": "medio",
  "alerts.severity.high": "alto",
  "alerts.severity.critical": "critico",
  "alerts.status.detected": "detectado",
  "alerts.status.acknowledged": "reconhecido",
  "alerts.status.snoozed": "adiado",
  "alerts.status.resolved": "resolvido",
  "alerts.status.dismissed": "descartado",
  "alerts.status.expired": "expirado",
  "alerts.source.expiration": "vencimento",
  "alerts.source.change": "alteracao",
  "alerts.refs.title": "Referencias de origem",
  "alerts.refs.open": "Abrir origem",
  "alerts.action.acknowledge": "Reconhecer",
  "alerts.action.snooze": "Adiar",
  "alerts.action.snoozeDays": "Dias",
  "alerts.action.resolve": "Resolver",
  "alerts.action.dismiss": "Descartar",
  "alerts.action.dismissReason": "Motivo (opcional)",
  "alerts.action.openSource": "Ver na origem",
  "dashboard.knowledge.title": "Painel de conhecimento",
  "dashboard.knowledge.loading": "Carregando...",
  "dashboard.knowledge.error": "Nao foi possivel carregar o painel.",
  "dashboard.knowledge.retry": "Tentar novamente",
  "dashboard.knowledge.placeholder": "Sem dados por enquanto.",
  "dashboard.knowledge.changesBySeverity": "Alteracoes por severidade",
  "dashboard.knowledge.changesByCategory": "Alteracoes por categoria",
  "dashboard.knowledge.expirationsByHorizon": "Vencimentos por horizonte",
  "dashboard.knowledge.alertsByStatus": "Alertas por estado",
  "knowledge.title": "Conhecimento",
  "knowledge.tabs.entities": "Entidades",
  "knowledge.tabs.expirations": "Vencimentos",
  "knowledge.loading": "Carregando…",
  "knowledge.retry": "Tentar novamente",
  "knowledge.entities.subtitle": "Entidades detectadas nos seus documentos.",
  "knowledge.entities.searchPlaceholder": "Buscar por nome ou alias…",
  "knowledge.entities.search": "Buscar",
  "knowledge.entities.sources": "Fontes",
  "knowledge.entities.empty": "Nenhuma entidade para mostrar.",
  "knowledge.entities.error": "Não foi possível carregar as entidades.",
  "knowledge.timeline.title": "Linha do tempo",
  "knowledge.timeline.empty": "Sem eventos legíveis para esta entidade.",
  "knowledge.timeline.error": "Não foi possível carregar a linha do tempo.",
  "knowledge.expirations.subtitle": "Próximos vencimentos detectados com evidência.",
  "knowledge.expirations.evidence": "Evidência",
  "knowledge.expirations.dismiss": "Descartar",
  "knowledge.expirations.dismissed": "Vencimento descartado.",
  "knowledge.expirations.dismissError": "Não foi possível descartar o vencimento.",
  "knowledge.expirations.empty": "Nenhum vencimento próximo.",
  "knowledge.expirations.error": "Não foi possível carregar os vencimentos.",
  "knowledge.type.cliente": "Cliente",
  "knowledge.type.proveedor": "Fornecedor",
  "knowledge.type.contrato": "Contrato",
  "knowledge.type.politica": "Política",
  "knowledge.type.area": "Área",
  "knowledge.type.riesgo": "Risco",
};
